import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonLayoutIconTitleContext } from "./cta-button-layout-icon-title.models";
import { CTAButtonLayout } from "../cta-button-layout";

@Component({
    selector: "dodo-cta-button-layout-icon-title",
    templateUrl: "./cta-button-layout-icon-title.component.html",
    styleUrls: ["./cta-button-layout-icon-title.component.scss"],
    standalone: false
})
export class CtaButtonLayoutIconTitleComponent extends CTAButtonLayout
	implements OnInit {
	@Input() iconImage: string;
	@Input() title: string;
	@Input() subtitle: string;
	@Input() source = "";

	@Input() set context(ctx: CTAButtonLayoutIconTitleContext) {
		if (ctx) {
			this.iconImage = this.iconImage || ctx.iconImage;
			this.title = this.title || ctx.title;
			this.subtitle = this.subtitle || ctx.subtitle;
		}
	}

	set layoutContext(ctx: CTAButtonLayoutIconTitleContext) {
		if (ctx) {
			this.iconImage = this.iconImage || ctx.iconImage;
			this.title = this.title || ctx.title;
		}
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
